module.exports = __webpack_public_path__ + "static/img_4687-d61442cc1b08d75a11c6b70fc250cc46.webp";